import { useT } from '../i18n/LangContext';

const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5000').replace(/\/+$/, '');

export default function Footer() {
  const { t } = useT();

  return (
    <footer style={s.footer}>
      <div style={s.inner}>
        <div style={s.links}>
          <a href={`${API_BASE}/privacy`} target="_blank" rel="noreferrer" style={s.a}>{t('footerPrivacy')}</a>
          <a href={`${API_BASE}/terms`} target="_blank" rel="noreferrer" style={s.a}>{t('footerTerms')}</a>
          <a href={`${API_BASE}/imprint`} target="_blank" rel="noreferrer" style={s.a}>{t('footerImprint')}</a>
        </div>
        <div style={s.links}>
          <a href="mailto:info@vbm-zukunftsbruecke.de" style={s.a}>info@vbm-zukunftsbruecke.de</a>
          <a href="tel:+4915128947109" style={s.a}>+49 151 28947109</a>
          <a href="https://www.instagram.com/vbmzukunftsbrucke/" target="_blank" rel="noreferrer" style={s.a}>Instagram</a>
          <a href="https://www.facebook.com/people/Vogel-Beratung-Management/61584408406842/" target="_blank" rel="noreferrer" style={s.a}>Facebook</a>
          <a href="https://www.linkedin.com/company/vogel-beratung-management-die-zukunftsbr%C3%BCcke/" target="_blank" rel="noreferrer" style={s.a}>LinkedIn</a>
        </div>
      </div>
    </footer>
  );
}

const s = {
  footer: {
    background: '#1a1a2e',
    color: '#aaa',
    padding: '20px 32px',
    fontFamily: 'Inter, sans-serif',
    fontSize: '13px',
  },
  inner: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  links: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    alignItems: 'center',
  },
  a: {
    color: '#aaa',
    textDecoration: 'none',
  },
};
